import JwtBaseClient from './JwtBaseClient';

/**
 * @class MyAcvServiceClient
 *
 * @description API wrapper for MyAcv Service API
 */
class MyAcvServiceClient extends JwtBaseClient {
  constructor() {
    super(
      `${import.meta.env.VITE_MY_ACV_BASE_URI}`,
      'response.data',
    );

    this.rootUri = 'api/v1';
  }

  /**
   * @function getSellerDashboardMetrics
   * @description Return an object with all the information about Seller Performance
   * for only one dealer.
   * @param {Number} dealerId
   * @returns {Promise}
   */
  getSellerDashboardMetrics(dealerId) {
    return this.get(`${this.rootUri}/seller_performance_metrics/${dealerId}`);
  }

  /**
   * @function getSummaryBalance
   * @description Return an object with accumulated amount invoices balance for a dealership
   * @param {string} dealer_ids
   * @returns {Promise}
   */
  getSummaryBalance(params) {
    return this.get(`${this.rootUri}/invoice/summary`, params);
  }

  /**
   * @function getInvoices
   * @description Return a list of invoice objects based on query params
   * @param {Number} page
   * @param {Number} size
   * @param {String} invoice_status
   * @param {String} query
   * @param {String} dealer_ids
   * @returns {Promise}
   */
  getInvoices(params) {
    return this.get(`${this.rootUri}/invoice`, params);
  }

  /**
   * @function getExport
   * @description Return a csv file with invoices data
   * @param {String} from_date
   * @param {String} to_date
   * @param {String} dealer_ids
   * @returns {Promise}
   */
  getExport(params) {
    return this.get(`${this.rootUri}/invoice/export`, params, null);
  }

  /**
   * @function getDownloadInvoice
   * @description Download an Invoice PDF based on invoices ids param
   * @param {String} invoice_ids
   * @returns {Promise}
   */
  getDownloadInvoice(invoiceId) {
    const params = {
      invoice_ids: invoiceId,
    };
    return this.get(`${this.rootUri}/invoice/download`, params, null);
  }
}

export default MyAcvServiceClient;
